/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
} from "@mui/material";
import { green } from "@mui/material/colors";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import CustomMaterialTable from "../../components/custom/CustomMaterialTable";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import MDTypography from "components/MDTypography";
import Loader from "components/custom/Loader";
import MDBox from "components/MDBox";

import Check from "@mui/icons-material/Check";
import ScheduleIcon from "@mui/icons-material/Schedule";
import DoneIcon from "@mui/icons-material/Done";
import { Button, Modal } from "antd";

import { useLocation } from "react-router-dom";
import { useMaterialUIController } from "context";
import { useNavigate } from "react-router-dom";
import useApiRequest from "utils/Apirequest";
import { AutoTooltip } from 'utils/Constant';

import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import { useSnackbar } from "notistack";
import "./somestyle.css";
import { useMemo } from "react";
import ActionModal from "./ActionModal";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import Co2Icon from "@mui/icons-material/Co2";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import BuildIcon from "@mui/icons-material/Build";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InfoIcon from "@mui/icons-material/Info";
import TuneIcon from "@mui/icons-material/Tune";
import { convertUTCtoDubai } from "utils/Constant";
import { DatePicker } from "antd";
import { MenuItem, Select } from "@mui/material";

import GlobalDateFilter from "utils/GlobalDateFilter";
import MDButton from "components/MDButton";


const QontoStepIconRoot = styled("div")(({ theme }) => ({
  color: "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  "& .QontoStepIcon-completedIcon": {
    color: "#784af4",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  ...theme.applyStyles("dark", {
    color: theme.palette.grey[700],
  }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        color: "#784af4",
      },
    },
  ],
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: ownerState.completed
    ? green[500]
    : ownerState.active
      ? "yellow"
      : "red",
}));

function ColorlibStepIcon(props) {
  const { active, completed, icon, className } = props;

  const icons = {
    1: <DoneIcon />,
    2: <DoneIcon />,
    3: <DoneIcon />,
    4: <ScheduleIcon />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const statusList1 = ["Active", "Completed"];

const ViewCharger = () => {
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [chargerInfo, setChargerInfo] = useState({});
  const [locationInfo, setLocationInfo] = useState({});
  const [columns, setColumns] = useState([]);
  const [rows1, setRows1] = useState([]);
  const [co2Saved, setCo2Saved] = useState("0 kg");
  const [kmsPowered, setKmsPowered] = useState("0 km");
  const [uptimeRate, setUptimeRate] = useState("0 %");
  const [isLoading1, setIsLoading1] = useState(true);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { sidenavColor } = controller;
  const [isActionModalOpen, setIsActionModalOpen] = useState(false);
  const [configurationData, setConfigurationData] = useState({});
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [timeRange, setTimeRange] = useState("today");

  const [specificConnector, setSpecificConnector] = useState({});
  const navigate = useNavigate();
  const handleTransactionEdit = (row_data) => {
    navigate("/session", { state: { _id: row_data?._id, chargerName: row_data?.chargerName } });
  };
  const apiRequest = useApiRequest();

  const fetchSession = async () => {
    const payload = {
      chargerId: location?.state?.charger_id,
      connectorId: location?.state?.connectorId,
      filter: timeRange,
      ...(timeRange === "custom" && {
        startDate: fromDate,
        endDate: toDate,
      }),
    };

    const { data, error } = await apiRequest('post', 'session/get-session-by-charger', payload, {}, {}, false) || {};

    if (data?.success) {
      setCo2Saved(data?.data.CO2Saved);
      setKmsPowered(data?.data.kmsPowered);
      setUptimeRate(data?.data.uptimeRate);
      const updatedRows = data?.data.sessions.map((session) => {
        const metadata = session.metadata || [];

        const firstEntry =
          metadata[0]?.values?.["Energy.Active.Import.Register"];
        const lastEntry =
          metadata[metadata.length - 1]?.values?.[
          "Energy.Active.Import.Register"
          ];

        const firstMeterValue = firstEntry
          ? parseFloat(firstEntry.split(" ")[0])
          : 0;
        const lastMeterValue = lastEntry
          ? parseFloat(lastEntry.split(" ")[0])
          : 0;

        const energyConsumed =
          lastMeterValue && firstMeterValue
            ? (lastMeterValue - firstMeterValue).toFixed(4)
            : "0";

        const energyUnit = session.energyDelivered || "Wh";

        const userPhone = session.userPhone || "";

        return {
          ...session,
          chargerName: chargerInfo?.chargerName || "N/A",
          status:
            session.status === "Started"
              ? "Active"
              : session.status === "Paid"
                ? "Completed"
                : session.status === "UnPaid"
                  ? "Completed"
                  : "Completed",
          energy_disp1: `${energyUnit} `,
          userPhone: userPhone,
        };
      });

      const sortedRows = updatedRows.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setRows1(sortedRows);
      setIsLoading1(false);
    }
    else {
      setIsLoading1(false);
      setRows1([]);
    }

  };


  const handleFilterChange = (filter) => {
    setIsLoading1(true);

    if (filter?.preset) {
      setTimeRange(filter?.preset);
      setFromDate(null);
      setToDate(null);
    }
    if (filter?.startDate && filter?.endDate) {
      setTimeRange("custom");
      setFromDate(filter.startDate);
      setToDate(filter.endDate);
    }
  };


  useEffect(() => {
    if (chargerInfo?.chargerName) {
      fetchSession();
    }
    setColumns(sessionColumn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chargerInfo?.chargerName, timeRange, fromDate, toDate]);

  const dashboardCharger = async () => {
    const payload = {
      connectorId: location?.state?.connectorId,
      chargerName: location?.state?.charger_id,
    };
    const { data } =
      (await apiRequest(
        "post",
        "charger-locations/get-charger-info-by-name",
        payload,
        {},
        {},
        false
      )) || {};

    if (data?.status === true) {
      setChargerInfo(data?.data?.chargerInfo);
      setLocationInfo(data?.data?.location);
      setSpecificConnector(data?.data?.specificConnector);
    }
  };


  const handleActionSubmit = (action) => {
    enqueueSnackbar(`Command "${action}" sent successfully!`, {
      variant: "success",
    });
  };


  const handleUpdateRFID = () => {
    Modal.confirm({
      title: "Are you sure?",
      content:
        "This action will update the RFID cards associated with this charger.",
      okText: "Yes, Update",
      cancelText: "Cancel",
      okType: "danger",
      centered: true,
      onOk: async () => {
        try {
          const payload = {
            "chargerId": chargerInfo?.name,
            "localListStatus": "Accepted"
          };

          const { data } = await apiRequest(
            "post",
            "local-list/update",
            payload,
            {},
            {},
            false
          );

          if (data?.success || data?.status === true) {
            enqueueSnackbar("RFID cards updated successfully!", {
              variant: "success",
            });
            window.location.reload();
          } else {
            enqueueSnackbar("Failed to update RFID cards.", {
              variant: "error",
            });
          }
        } catch (error) {
          enqueueSnackbar("Something went wrong while updating RFID cards.", {
            variant: "error",
          });
        }
      },
    });
  };

  const handleAutoStartDisabled = () => {
    Modal.confirm({
      title: "Are you sure?",
      content:
        "This action will disabled autostart session on the charger.",
      okText: "Yes, Update",
      cancelText: "Cancel",
      okType: "danger",
      centered: true,
      onOk: async () => {
        try {
          const payload = {
            "charger_id": chargerInfo?._id,
            "location_id": locationInfo?.locationId,
            "updatedChargerInfo": {
              autoStart: false
            }
          };

          const { data } = await apiRequest(
            "patch",
            "charger-locations/update-charger-connector",
            payload,
            {},
            {},
            false,
            false
          );

          if (data?.success || data?.status === true) {
            enqueueSnackbar("Autostart command accepted successfully", {
              variant: "success",
            });
            window.location.reload();
          } else {
            enqueueSnackbar("Failed to send command.", {
              variant: "error",
            });
          }
        } catch (error) {
          enqueueSnackbar("Something went wrong while updating RFID cards.", {
            variant: "error",
          });
        }
      },
    });
  };
  const handleAutoStartEnabled = () => {
    Modal.confirm({
      title: "Are you sure?",
      content:
        "This action will enabled autostart session on the charger.",
      okText: "Yes, Update",
      cancelText: "Cancel",
      okType: "danger",
      centered: true,
      onOk: async () => {
        try {
          const payload = {
            "charger_id": chargerInfo?._id,
            "location_id": locationInfo?.locationId,
            "updatedChargerInfo": {
              autoStart: true
            }
          };

          const { data } = await apiRequest(
            "patch",
            "charger-locations/update-charger-connector",
            payload,
            {},
            {},
            false,
            false
          );

          if (data?.success || data?.status === true) {
            enqueueSnackbar("Autostart command accepted successfully", {
              variant: "success",
            });
            window.location.reload();
          } else {
            enqueueSnackbar("Failed to send command.", {
              variant: "error",
            });
          }
        } catch (error) {
          enqueueSnackbar("Something went wrong while updating RFID cards.", {
            variant: "error",
          });
        }
      },
    });
  };


  useEffect(() => {
    if (!chargerInfo?.name) {
      return;
    }
    const configData = async () => {
      const payload = {
        chargerId: chargerInfo?.name,
        action: "GetConfiguration",
        payload: {
          key: [],
        },
      };

      const { data } =
        (await apiRequest(
          "post",
          `session/charger-command`,
          payload,
          {},
          {},
          false,
          false
        )) || {};

      if (data?.status === true) {
        setConfigurationData(data?.data?.configurationKey);
      }
    };

    configData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chargerInfo?.name]);


  useEffect(() => {
    dashboardCharger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state])

  const sessionColumn = useMemo(() => [
    {
      header: "Status",
      accessorKey: "status",
      filterVariant: 'select',
      filterSelectOptions: statusList1,
      align: "center",
      fixed: "true", muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        align: 'center',
      },
      Cell: (row) => (
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          borderRadius="md"
          bgcolor="rgba(25, 128, 56, 0.2)"
          style={{
            flex: 1,
          }}
        >
          <Tag color={row.row.original.status === "Completed" ? "green" : row.row.original.status === "Active" ? "blue" : "yellow"}>{row.row.original.status}</Tag>
        </MDBox>
      ),
    },
    {
      header: "Session ID", accessorKey: "_id", align: "center", muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        align: 'center',
      },
      Cell: ({ row }) => {
        const sessionId = row?.original?._id;
        return (
          <AutoTooltip maxWidth={150}><span
            onClick={(e) => handleTransactionEdit(row?.original)}
            style={{
              color: "#1E88E5",
              cursor: "pointer",
              textDecoration: "underline",
            }}

          >
            {sessionId}
          </span>
          </AutoTooltip>
        );
      }
    },
    {
      header: "Charger ID", accessorKey: "chargerId", align: "center", muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        align: 'center',
      },
      Cell: ({ row }) => {
        return (
          <span

          >
            {row?.original?.chargerId} - {row?.original?.connectorId}
          </span>
        );
      }
    },
    {
      header: "Charger Name", accessorKey: "chargerName", align: "center", muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        align: 'center',
      },
      Cell: ({ row }) => {
        return (
          <span
          >
            {row?.original?.chargerName}
          </span>
        );
      }
    },

    {
      header: "Driver ID",
      accessorKey: "userPhone",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      header: "Start SOC",
      accessorKey: "startSOC",
      size: 230,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      header: "End SOC",
      accessorKey: "finalSOC",
      size: 230,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return value === null || value === undefined ? "N/A" : value;
      },
    },
    {
      header: "CO2 Saved",
      accessorKey: "co2Saved",
      size: 230,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      header: "Cost",
      accessorKey: "totalRevenue",
      size: 230,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      header: "Start Date & Time",
      accessorKey: "startTime",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ cell }) => {
        return convertUTCtoDubai(cell.getValue());
      },
    },
    {
      header: "End Date & Time",
      accessorKey: "endTime",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ cell }) => {
        return convertUTCtoDubai(cell.getValue());
      },
    },
    {
      header: "Duration",
      accessorKey: "duration",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      header: "Location",
      accessorKey: "chargerLocation.locationName",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },

    {
      header: "Energy disperse (kWh)",
      accessorKey: "energyFromMeta",
      align: "center",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      size: 300,
    }

  ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sidenavColor]
  );

  useEffect(() => {
    setColumns(sessionColumn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sidenavColor]);

  const handleView = () => {
    navigate("/location/view", { state: locationInfo?.locationId });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={2}>
        <Card
          sx={{
            mb: 3,
            boxShadow: darkMode
              ? "0 4px 12px rgba(0,0,0,0.3)"
              : "0 4px 12px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            border: "1px solid",
            borderColor: darkMode
              ? "rgba(255,255,255,0.1)"
              : "rgba(0,0,0,0.08)",
          }}
        >
          <MDBox p={3}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
              flexWrap="wrap"
              gap={2}
            >
              <MDBox display="flex" alignItems="center" gap={2}>
                {specificConnector?.status === "Available" ? (
                  <Tag
                    icon={<CheckCircleOutlined />}
                    color="success"
                    style={{
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                      padding: "6px 16px",
                      borderRadius: "12px",
                    }}
                  >
                    Available
                  </Tag>
                ) : specificConnector?.status === "Preparing" ? (
                  <Tag
                    icon={<SyncOutlined spin />}
                    color="warning"
                    style={{
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                      padding: "6px 16px",
                      borderRadius: "12px",
                    }}
                  >
                    Preparing
                  </Tag>
                ) : specificConnector?.status === "Inactive" ? (
                  <Tag
                    icon={<CloseCircleOutlined />}
                    color="error"
                    style={{
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                      padding: "6px 16px",
                      borderRadius: "12px",
                    }}
                  >
                    Inactive
                  </Tag>
                ) : specificConnector?.status === "Charging" ? (
                  <Tag
                    icon={<LoadingOutlined />}
                    color="#1A73E8"
                    style={{
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                      padding: "6px 16px",
                      borderRadius: "12px",
                    }}
                  >
                    Charging
                  </Tag>
                ) : specificConnector?.status === "Finishing" ? (
                  <Tag
                    icon={<ExclamationCircleOutlined />}
                    color="#800080"
                    style={{
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                      padding: "6px 16px",
                      borderRadius: "12px",
                    }}
                  >
                    Finishing
                  </Tag>
                ) : specificConnector?.status === "Faulted" ? (
                  <Tag
                    icon={<MinusCircleOutlined />}
                    color="#E64A19"
                    style={{
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                      padding: "6px 16px",
                      borderRadius: "12px",
                    }}
                  >
                    Faulted
                  </Tag>
                ) : (
                  <Tag
                    icon={<ClockCircleOutlined />}
                    color="default"
                    style={{
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                      padding: "6px 16px",
                      borderRadius: "12px",
                    }}
                  >
                    {specificConnector?.status}
                  </Tag>
                )}
              </MDBox>

            </MDBox>

            <MDTypography variant="h3" fontWeight="bold" mb={2}>
              {chargerInfo?.name} - {specificConnector?.connectorId} ( {chargerInfo?.chargerName} )
            </MDTypography>



            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <MDBox>
                  <MDTypography
                    variant="caption"
                    sx={{
                      opacity: 0.7,
                      textTransform: "uppercase",
                      fontSize: "0.65rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Charger Type
                  </MDTypography>
                  <MDTypography variant="body1" fontWeight="medium" mt={0.3}>
                    {chargerInfo?.type} - {chargerInfo?.powerOutput}
                  </MDTypography>
                </MDBox>

              </Grid>

              <Grid item xs={12} sm={6}>
                <MDBox>
                  <MDTypography
                    variant="caption"
                    sx={{
                      opacity: 0.7,
                      textTransform: "uppercase",
                      fontSize: "0.65rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    City & State
                  </MDTypography>
                  <MDTypography variant="body1" fontWeight="medium" mt={0.3}>
                    {locationInfo?.city}, {locationInfo?.state}
                  </MDTypography>
                </MDBox>

              </Grid>
              <Grid item xs={12} sm={6}>
                <MDBox>
                  <MDTypography
                    variant="caption"
                    sx={{
                      opacity: 0.7,
                      textTransform: "uppercase",
                      fontSize: "0.65rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Location
                  </MDTypography>
                  <MDTypography variant="body1" fontWeight="medium" mt={0.3}>
                    {locationInfo?.locationName} | {locationInfo?.locationType}
                  </MDTypography>
                </MDBox>
                <MDBox mt={2} display="flex" gap={2}>
                  {/* <Button
                    type="primary"
                    danger
                    size="large"
                    onClick={handleUpdateRFID}
                  >
                    Update RFID Cards
                  </Button> */}
                  {chargerInfo?.autoStart ? (
                    <Button
                      type="primary"
                      danger
                      size="large"
                      onClick={handleAutoStartDisabled}
                    >
                      Auto Start Disabled
                    </Button>
                  ) : (
                    <Button
                      type="primary"
                      size="large"
                      style={{ backgroundColor: "#75c43d", borderColor: "#75c43d" }}
                      onClick={handleAutoStartEnabled}
                    >
                      Auto Start Enabled
                    </Button>
                  )}
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </Card>

        {/* <Grid container spacing={3} mb={3}>
          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                boxShadow: darkMode
                  ? "0 4px 12px rgba(0,0,0,0.3)"
                  : "0 4px 12px rgba(0,0,0,0.1)",
                borderRadius: "16px",
                border: "1px solid",
                borderColor: darkMode
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.08)",
                height: "100%",
              }}
            >
              <MDBox p={3}>
                <MDBox display="flex" alignItems="center" gap={2} mb={2}>
                  <MDBox
                    sx={{
                      background: "linear-gradient(195deg, #42A5F5, #1976D2)",
                      borderRadius: "12px",
                      padding: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 12px rgba(66, 165, 245, 0.3)",
                    }}
                  >
                    <DirectionsCarIcon
                      sx={{ color: "#ffffff", fontSize: "28px" }}
                    />
                  </MDBox>
                  <MDBox>
                    <MDTypography
                      variant="caption"
                      sx={{
                        opacity: 0.7,
                        textTransform: "uppercase",
                        fontSize: "0.65rem",
                        letterSpacing: "0.5px",
                      }}
                    >
                      KMS Powered
                    </MDTypography>
                    <MDTypography variant="h4" fontWeight="bold">
                      {kmsPowered}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                boxShadow: darkMode
                  ? "0 4px 12px rgba(0,0,0,0.3)"
                  : "0 4px 12px rgba(0,0,0,0.1)",
                borderRadius: "16px",
                border: "1px solid",
                borderColor: darkMode
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.08)",
                height: "100%",
              }}
            >
              <MDBox p={3}>
                <MDBox display="flex" alignItems="center" gap={2} mb={2}>
                  <MDBox
                    sx={{
                      background: "linear-gradient(195deg, #66BB6A, #43A047)",
                      borderRadius: "12px",
                      padding: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 12px rgba(102, 187, 106, 0.3)",
                    }}
                  >
                    <Co2Icon sx={{ color: "#ffffff", fontSize: "28px" }} />
                  </MDBox>
                  <MDBox>
                    <MDTypography
                      variant="caption"
                      sx={{
                        opacity: 0.7,
                        textTransform: "uppercase",
                        fontSize: "0.65rem",
                        letterSpacing: "0.5px",
                      }}
                    >
                      CO2 Saved
                    </MDTypography>
                    <MDTypography variant="h4" fontWeight="bold">
                      {co2Saved}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                boxShadow: darkMode
                  ? "0 4px 12px rgba(0,0,0,0.3)"
                  : "0 4px 12px rgba(0,0,0,0.1)",
                borderRadius: "16px",
                border: "1px solid",
                borderColor: darkMode
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.08)",
                height: "100%",
              }}
            >
              <MDBox p={3}>
                <MDBox display="flex" alignItems="center" gap={2} mb={2}>
                  <MDBox
                    sx={{
                      background: "linear-gradient(195deg, #FFA726, #FB8C00)",
                      borderRadius: "12px",
                      padding: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 12px rgba(255, 167, 38, 0.3)",
                    }}
                  >
                    <TrendingUpIcon
                      sx={{ color: "#ffffff", fontSize: "28px" }}
                    />
                  </MDBox>
                  <MDBox>
                    <MDTypography
                      variant="caption"
                      sx={{
                        opacity: 0.7,
                        textTransform: "uppercase",
                        fontSize: "0.65rem",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Uptime Rate
                    </MDTypography>
                    <MDTypography variant="h4" fontWeight="bold">
                      {uptimeRate}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid> */}

        <Card
          sx={{
            mb: 3,
            boxShadow: darkMode
              ? "0 4px 12px rgba(0,0,0,0.3)"
              : "0 4px 12px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            border: "1px solid",
            borderColor: darkMode
              ? "rgba(255,255,255,0.1)"
              : "rgba(0,0,0,0.08)",
          }}
        >
          <MDBox>
            <Accordion
              sx={{
                "&:before": { display: "none" },
                boxShadow: "none",
                borderBottom: "1px solid",
                borderColor: darkMode
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.08)",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "transparent",
                  padding: "16px 24px",
                  "&:hover": {
                    backgroundColor: darkMode
                      ? "rgba(255,255,255,0.05)"
                      : "rgba(0,0,0,0.02)",
                  },
                }}
              >
                <MDBox display="flex" alignItems="center" gap={2}>
                  <MDBox
                    sx={{
                      background: "linear-gradient(195deg, #ef0000, #ef0000)",
                      borderRadius: "10px",
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(239, 0, 0, 0.3)",
                    }}
                  >
                    <BuildIcon sx={{ color: "#ffffff", fontSize: "20px" }} />
                  </MDBox>
                  <MDTypography variant="h6" fontWeight="bold">
                    Maintenance
                  </MDTypography>
                </MDBox>
              </AccordionSummary>
              <AccordionDetails sx={{ pt: 2, pb: 3, px: 3 }}>
                <Box my={2}>
                  <Box display="flex" flexDirection="column" gap={2}>
                    <Box display="flex" justifyContent="space-between">
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        width={"100%"}
                        sx={{
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                          },
                        }}
                      >
                        <Typography variant="body2" fontWeight="bold">
                          Charge Status:
                        </Typography>
                        <Typography variant="body2">
                          {specificConnector?.status}
                        </Typography>
                      </Box>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        width={"100%"}
                        sx={{
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                          },
                        }}
                      >
                        <Typography variant="body2" fontWeight="bold">
                          Last Ping:
                        </Typography>
                        <Typography variant="body2">
                          {convertUTCtoDubai(specificConnector?.lastPing)}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
            <Accordion
              sx={{
                "&:before": { display: "none" },
                boxShadow: "none",
                borderBottom: "1px solid",
                borderColor: darkMode
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.08)",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "transparent",
                  padding: "16px 24px",
                  "&:hover": {
                    backgroundColor: darkMode
                      ? "rgba(255,255,255,0.05)"
                      : "rgba(0,0,0,0.02)",
                  },
                }}
              >
                <MDBox display="flex" alignItems="center" gap={2}>
                  <MDBox
                    sx={{
                      background: "linear-gradient(195deg, #42A5F5, #1976D2)",
                      borderRadius: "10px",
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(66, 165, 245, 0.3)",
                    }}
                  >
                    <LocationOnIcon
                      sx={{ color: "#ffffff", fontSize: "20px" }}
                    />
                  </MDBox>
                  <MDTypography variant="h6" fontWeight="bold">
                    Location
                  </MDTypography>
                </MDBox>
              </AccordionSummary>
              <AccordionDetails sx={{ pt: 2, pb: 3, px: 3 }}>
                <Box my={2}>
                  <Box display="flex" flexDirection="column" gap={2}>
                    <Box display="flex" justifyContent="space-between">
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        width={"100%"}
                        sx={{
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                          },
                        }}
                      >
                        <Typography variant="body2" fontWeight="bold">
                          Location Name:
                        </Typography>
                        <Typography
                          variant="body2"
                          onClick={handleView}
                          sx={{
                            cursor: "pointer",
                            color: "#1A73E8",
                            textDecoration: "underline",
                            "&:hover": {
                              color: "#0d47a1",
                            },
                          }}
                        >
                          {locationInfo?.locationName}
                        </Typography>
                      </Box>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        width={"100%"}
                        sx={{
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                          },
                        }}
                      >
                        <Typography variant="body2" fontWeight="bold">
                          Location Type:
                        </Typography>
                        <Typography variant="body2">
                          {locationInfo?.locationType}
                        </Typography>
                      </Box>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        width={"100%"}
                        sx={{
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                          },
                        }}
                      >
                        <Typography variant="body2" fontWeight="bold">
                          Location Address:
                        </Typography>
                        <Typography
                          variant="body2"
                        // onClick={handleView}
                        // sx={{
                        //   cursor: "pointer",
                        //   color: "#1A73E8",
                        //   textDecoration: "underline",
                        //   "&:hover": {
                        //     color: "#0d47a1",
                        //   },
                        // }}
                        >
                          {locationInfo?.address}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
            <Accordion
              sx={{
                "&:before": { display: "none" },
                boxShadow: "none",
                borderBottom: "1px solid",
                borderColor: darkMode
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.08)",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "transparent",
                  padding: "16px 24px",
                  "&:hover": {
                    backgroundColor: darkMode
                      ? "rgba(255,255,255,0.05)"
                      : "rgba(0,0,0,0.02)",
                  },
                }}
              >
                <MDBox display="flex" alignItems="center" gap={2}>
                  <MDBox
                    sx={{
                      background: "linear-gradient(195deg, #66BB6A, #43A047)",
                      borderRadius: "10px",
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(102, 187, 106, 0.3)",
                    }}
                  >
                    <InfoIcon sx={{ color: "#ffffff", fontSize: "20px" }} />
                  </MDBox>
                  <MDTypography variant="h6" fontWeight="bold">
                    More Info
                  </MDTypography>
                </MDBox>
              </AccordionSummary>
              <AccordionDetails sx={{ pt: 2, pb: 3, px: 3 }}>
                <Box my={2}>
                  <Box display="flex" flexDirection="column" gap={2}>
                    <Box display="flex" justifyContent="space-between">
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        width={"100%"}
                        sx={{
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                          },
                        }}
                      >
                        <Typography variant="body2" fontWeight="bold">
                          Charger Name:
                        </Typography>
                        <Typography variant="body2">
                          {chargerInfo?.chargerName}
                        </Typography>
                      </Box>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        width={"100%"}
                        sx={{
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                          },
                        }}
                      >
                        <Typography variant="body2" fontWeight="bold">
                          Charger ID:
                        </Typography>
                        <Typography variant="body2">
                          {chargerInfo?.name}
                        </Typography>
                      </Box>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        width={"100%"}
                        sx={{
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                          },
                        }}
                      >
                        <Typography variant="body2" fontWeight="bold">
                          Charger Type:
                        </Typography>
                        <Typography variant="body2">
                          {chargerInfo?.type}
                        </Typography>
                      </Box>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        width={"100%"}
                        sx={{
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                          },
                        }}
                      >
                        <Typography variant="body2" fontWeight="bold">
                          Charger Power:
                        </Typography>
                        <Typography variant="body2">
                          {chargerInfo?.powerOutput}
                        </Typography>
                      </Box>
                    </Box>
                    {chargerInfo?.otherDatas &&
                      Object.entries(chargerInfo?.otherDatas).map(([key, value]) => {

                        const customLabels = {
                          chargePointSerialNumber: "Charger Serial Number",
                        };

                        const displayLabel =
                          customLabels[key] ||
                          key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());

                        return (
                          <Box key={key} display="flex" justifyContent="space-between" >
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              width={"100%"}
                              sx={{
                                flexDirection: {
                                  xs: "column",
                                  sm: "row",
                                },
                              }}
                            >
                              <Typography variant="body2" fontWeight="bold">
                                {displayLabel}:
                              </Typography>
                              <Typography variant="body2">
                                {typeof value === "object" ? JSON.stringify(value) : value}
                              </Typography>

                            </Box>
                          </Box>
                        );
                      })}
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
            <Accordion
              sx={{
                "&:before": { display: "none" },
                boxShadow: "none",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "transparent",
                  padding: "16px 24px",
                  "&:hover": {
                    backgroundColor: darkMode
                      ? "rgba(255,255,255,0.05)"
                      : "rgba(0,0,0,0.02)",
                  },
                }}
              >
                <MDBox display="flex" alignItems="center" gap={2}>
                  <MDBox
                    sx={{
                      background: "linear-gradient(195deg, #FFA726, #FB8C00)",
                      borderRadius: "10px",
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(255, 167, 38, 0.3)",
                    }}
                  >
                    <TuneIcon sx={{ color: "#ffffff", fontSize: "20px" }} />
                  </MDBox>
                  <MDTypography variant="h6" fontWeight="bold">
                    Configuration Details
                  </MDTypography>
                </MDBox>
              </AccordionSummary>
              <AccordionDetails sx={{ pt: 2, pb: 3, px: 3 }}>
                <Box my={2}>
                  <Box display="flex" flexDirection="column" gap={2}>
                    {Array.isArray(configurationData) ? (
                      configurationData.map((item) => (
                        <Box
                          key={item.key}
                          display="flex"
                          justifyContent="space-between"
                          my={1}
                          sx={{
                            flexDirection: { xs: "column", sm: "row" },
                          }}
                        >
                          <Typography
                            variant="body2"
                            fontWeight="bold"
                            sx={{ wordBreak: "break-all", mr: 2 }}
                          >
                            {item.key}
                            {item.readonly && (
                              <span
                                style={{
                                  marginLeft: "8px",
                                  fontSize: "0.7rem",
                                  color: "#9e9e9e",
                                  fontWeight: "normal",
                                }}
                              >
                                (Read-Only)
                              </span>
                            )}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              textAlign: { xs: "left", sm: "right" },
                              wordBreak: "break-all",
                            }}
                          >
                            {String(item.value)}
                          </Typography>
                        </Box>
                      ))
                    ) : (
                      <Typography>No configuration data found.</Typography>
                    )}
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
          </MDBox>
        </Card>

        <MDBox mt={8}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={1}
              px={2}
              variant="gradient"
              bgColor={sidenavColor}
              borderRadius="lg"
              coloredShadow="info"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <MDTypography variant="h6" color="white">
                Sessions
              </MDTypography>


            </MDBox>

            <MDBox mt={3} px={{ xs: 1, sm: 2 }}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <GlobalDateFilter
                    onChange={handleFilterChange}
                  />
                  {isLoading1 ? (
                    <Loader />
                  ) : (
                    <Box mt={2}>
                      <CustomMaterialTable
                        columns={columns}
                        data={rows1}
                        darkMode={darkMode}
                      />
                    </Box>
                  )}
                </Grid>
              </Grid>
            </MDBox>
          </Card>
        </MDBox>
      </MDBox>
      <ActionModal
        open={isActionModalOpen}
        onClose={() => setIsActionModalOpen(false)}
        onSubmit={handleActionSubmit}
        chargerInfo={chargerInfo}
        specificConnector={specificConnector}
        configData={configurationData}
      />
    </DashboardLayout>
  );
};

export default ViewCharger;

